import { render, staticRenderFns } from "./live-lecture-attendance-stats-chart.vue?vue&type=template&id=05048257&scoped=true"
import script from "./live-lecture-attendance-stats-chart.vue?vue&type=script&lang=js"
export * from "./live-lecture-attendance-stats-chart.vue?vue&type=script&lang=js"
import style0 from "./live-lecture-attendance-stats-chart.vue?vue&type=style&index=0&id=05048257&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05048257",
  null
  
)

export default component.exports